

const NewsCard = ({ image, title, author, category, date, link }) => {
  return (
    <div className="card rounded-0 border-0 shadow-sm">
      <div className="position-relative image-container" style={{ height: "250px", overflow: "hidden" }}>
        <img
          src={image}
          alt={title}
          className="card-img-top img-fluid"
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 60vw"
          style={{ objectFit: "cover" }}
          />
      </div>

      <div className="card-body p-4">
        <div className="d-flex text-muted small gap-3">
          <span className="me-3">
            <i className="bi bi-person-fill text-primary me-1"></i> By:  {author}
          </span>
          <span>
            <i className="bi bi-tag-fill text-primary me-1"></i> {category}
          </span>
        </div>

        <h5 className="card-title fw-bold text-dark text-start py-4">
          <a href={link} className="text-decoration-none text-dark brand">
            {title}
          </a>
        </h5>

        <div className="d-flex border-top justify-content-between align-items-center pt-4 small text-muted">
          <div className="d-flex align-items-center">
            <i className="bi bi-calendar-date text-primary me-2"></i> {date}
          </div>
          <a href={link} className="text-primary fw-bold text-decoration-none">
            READ MORE
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;